module.exports = __webpack_public_path__ + "static/media/GarmentSteamersbanner.338d8425.png";